query tipoModeloAjuizamentoSelect {
  data: tipoModeloAjuizamento {
    value
    label
  }
}